
import React from "react";


const ads = [
    {
      title: "2025_04_OralB_RM_FP_Standard_300x600_v1_300x600 (ID: 1527450)",
      id: 1547295,
      dimensions: "300x600",
      width: 300,
      height: 600,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/6810dc7f2b073/Standard_300x600_v1/assets/vid.mp4#t=0.01",
    },
    {
      title: "2025_04_OralB_RM_FP_Standard_300x250_v1_300x250 (ID: 1540258)",
      id: 1547296,
      dimensions: "300x250",
      width: 300,
      height: 250,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/6826159ec950b/Standard_300x250_v1/assets/vid.mp4#t=0.01",
    },
    {
      title: "2025_04_OralB_RM_FP_Standard_320x480_v1_320x480 (ID: 1540259)",
      id: 1547297,
      dimensions: "320x480",
      width: 320,
      height: 480,
      videoSrc:
        "https://dsp.eskimi.com/files/upload/rm/upload/68261383515bc/Standard_320x480_v1/assets/vid.mp4#t=0.01",
    },
    {
        title: "2025_04_OralB_RM_FP_Standard_300x600_v1_AR_300x600 (ID: 1542649)",
        id: 1547297,
        dimensions: "320x600",
        width: 320,
        height: 600,
        videoSrc:
          "https://dsp.eskimi.com/files/upload/rm/upload/682c7e8b4bf2e/Standard_300x600_v1_AR/assets/vid.mp4#t=0.01",
      },
      {
        title: "2025_04_OralB_RM_FP_Standard_320x250_v1_320x480 (ID: 1540259)",
        id: 1547297,
        dimensions: "320x250",
        width: 320,
        height: 250,
        videoSrc:
          "https://dsp.eskimi.com/files/upload/rm/upload/682f34a96c5b5/Standard_300x250_v1_AR/assets/vid.mp4#t=0.01",
      },
      {
        title: "2025_04_OralB_RM_FP_Standard_320x480_v1_320x480 (ID: 1540259)",
        id: 1547297,
        dimensions: "320x480",
        width: 320,
        height: 480,
        videoSrc:
          "https://dsp.eskimi.com/files/upload/rm/upload/68261383515bc/Standard_320x480_v1/assets/vid.mp4#t=0.01",
      },
  ];
  
  const OralDetail = () => {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8 space-y-10 mt-14">
        <h3 className="text-xl font-bold text-black">
        Eskimi DSP 2025_04_OralB_RM_FP (ID: 235886) campaign preview
        </h3>
  
        {ads.map((ad) => (
          <div key={ad.id} className="space-y-2">
            <h4 className="font-semibold text-sm sm:text-base text-black">
              {ad.title} (ID: {ad.id})
            </h4>
            <div
              className="overflow-hidden rounded border border-gray-300"
              style={{ width: ad.width, height: ad.height }}
            >
              <video
                src={ad.videoSrc}
                autoPlay
                muted
                loop
                playsInline
                width={ad.width}
                height={ad.height}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-xs text-gray-600">({ad.dimensions})</p>
          </div>
        ))}
      </div>
  );
};

export default OralDetail;